import {
  InMemoryHeader,
  InMemoryString,
} from "pbas-vue-components";


function getHeaders() {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      type: new InMemoryString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "globals.logo",
      type: new InMemoryString("Logo", {
        getHtml: (item, type) => {
          return (
            `<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>
            <a href="${item.Logo}" target="_blank">${item.Logo}</a>
            </div>`
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "components.portal.plan_settings.plan_administrator",
      type: new InMemoryString("PlanAdministrator"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "components.portal.plan_settings.plan_administrator_name",
      type: new InMemoryString("PlanAdministratorName"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.left_drawer_menu_items.url",
      type: new InMemoryString("Url"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  ]
  return headers;
}
export default getHeaders;
